import ButtonCommon from 'components/common/ButtonCommon';
import SizeBox from 'components/common/SizeBox';
import {
  DESKTOP_MIN_WIDTH,
  FUNC_DEFAULT,
  MOBILE_MIN_WIDTH,
  TABLET_MAX_WIDTH,
} from 'constants';
import useLang from 'hooks/useLang';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import { paragraph500Mixin, paragraph700Mixin } from 'styles';

const ConfirmCancelFormEditPopup = ({
  isOpen,
  onClose,
  onClick,
  isBackdropOverlap,
  zIndexBackdropOverlap,
  zIndexModal = 0,
}) => {
  const { t } = useLang();

  const renderBodyContent = () => {
    return (
      <>
        <Text>{t('label_cancel_update')}</Text>
        <SizeBox height={4} />
        <SubText
          dangerouslySetInnerHTML={{
            __html: t('popup_confirm_cancel_form_edit_desc'),
          }}
        />
        <SizeBox height={24} />
      </>
    );
  };

  const renderActionButton1 = (width) => (
    <ButtonCommon
      value={t('button_no')}
      onClick={onClose}
      styles={{
        margin: '0px',
        height: '50px',
        width,
      }}
      color="var(--ds-c-blue)"
      background="var(--ds-c-white)"
    />
  );
  const renderActionButton2 = (width) => (
    <ButtonCommon
      value={t('button_yes')}
      color="var(--c-primary)"
      background="var(--bg-primary)"
      isFill={true}
      styles={{
        margin: '0px',
        height: '50px',
        width,
      }}
      onClick={onClick}
      isUseKeyDown
    />
  );
  const renderActionButtons = () => {
    return (
      <>
        {renderActionButton1('50%')}
        {renderActionButton2('50%')}
      </>
    );
  };

  return (
    <>
      <style>
        {zIndexModal &&
          `
          .confirm-cancel-form-edit-modal {
            z-index: ${zIndexModal || '1101'};
          }
        `}
        {isBackdropOverlap
          ? `
          .confirm-cancel-form-edit-modal-backdrop {
            z-index: ${zIndexBackdropOverlap || '1100'}!important;
            background: #212121;
            opacity: 0.7!important;
            display: initial!important;
          }
        `
          : `
        .confirm-cancel-form-edit-modal-backdrop {
          background: #212121;
          opacity: 0.7!important;
          display: initial!important;
        }
      `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={FUNC_DEFAULT}
        aria-labelledby="contained-modal-title-vcenter"
        className="confirm-cancel-form-edit-modal"
        backdropClassName="confirm-cancel-form-edit-modal-backdrop"
        centered
      >
        <ModalBody>{renderBodyContent()}</ModalBody>
        <ModalFooter>{renderActionButtons()}</ModalFooter>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  & .modal-dialog {
    transform: none;
    & .modal-content {
      padding: 16px;
      border-radius: 8px;
      box-shadow: var(--ds-bs-4);
      background: var(--ds-c-white);
      width: 100%;
      height: fit-content;
      margin-inline: auto;
      border: none;
    }
  }

  @media screen and (min-width: ${MOBILE_MIN_WIDTH}px) and (max-width: ${TABLET_MAX_WIDTH -
    1}px) {
    padding: 16px !important;
    & .modal-dialog {
      margin: 0;
      margin-inline: auto;
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    padding-right: 0px !important;
    & .modal-dialog {
      & .modal-content {
        width: 436px;
      }
    }
  }
`;

const ModalBody = styled(Modal.Body)`
  padding: 0;
  text-align: left;
`;

const Text = styled.p`
  ${paragraph700Mixin};
  text-align: center;
`;
const SubText = styled.p`
  ${paragraph500Mixin};
  text-align: center;

  & a {
    text-decoration: none;
    color: var(--ds-c-blue-hyperlink-default);
  }

  & b {
    color: var(--ds-c-blue-hyperlink-default);
  }
`;

const ModalFooter = styled(Modal.Footer)`
  border: none;
  padding: 0;
  display: flex;
`;

export default ConfirmCancelFormEditPopup;
